import { h } from 'preact'
import { uuid } from 'app/util'
import cxs from 'cxs'

const className = cxs({
  padding: '0.5rem',
  fontSize: '1rem',
  border: '2px solid #f6f6f6',
  borderRadius: 0,
  backgroundColor: '#f6f6f6',
  color: '#343334',
  '-webkit-appearance': 'none',
  '-moz-appearance': 'none',
  appearance: 'none',
  height: '41px',
  ':disabled': {
    color: '#a8a8a8',
  },
})

const labelClass = cxs({
  fontWeight: 'bold',
  display: 'flex',
  lineHeight: '1.3em',
})

const Input = ({
  type = 'text',
  label = '',
  value,
  optional,
  onInput,
  placeholder = '',
  ...rest
}) => {
  const id = uuid()

  return (
    <div class={rest.containerClass || ''}>
      <label class={labelClass} for={id}>
        {label}{' '}
        {!optional ? null : <span class="text-muted font-weight-light font-sm ml-2">Optional</span>}
      </label>
      <input
        id={id}
        type={type}
        value={value}
        onInput={onInput}
        placeholder={placeholder}
        {...rest}
        class={`${className} ${rest.class}`}
      />
    </div>
  )
}

export default Input



// WEBPACK FOOTER //
// ./components/Input.js